<template>
<div class="language-import">
  <h3>{{ $t('vform.importLanguage') }} Export</h3>
  <div class="lighter">{{ $t('vform.languageImportHint') }}</div>
  <label class="vform-label white mb-0 mt-3">{{ $t('vform.targetLanguage') }}</label>
  <language-selector
      :use-plain-language="true"
      class="mr-3 language-selector-bottom-bar align-self-center no-shadow"
      open-direction="top"
      @update="(newlang) => {targetLanguage = newlang}"
  />
  <div class="translation-upload mt-2">
    <upload-drop-zone
        v-if="targetLanguage"
        accepted-file-types=".po"
        asset-id="fake-asset-id"
        :auto-update-preview="false"
        :auto-upload="false"
        :downloadable="false"
        :image-editable="true"
        :removable="false"
        asset-type="assembly"
        :form-id="formId"
        :organization-id="organizationId"
        target-type="Asset"
        @data="setTranslationData"
        @queueEmpty="queueEmpty"
    >
      <div class="mt-2">
        {{ $t("vform.uploadTranslationFile") }}
      </div>
    </upload-drop-zone>
  </div>
  <div v-if="completed" class="form-error p-1 mt-2">
    {{ $t('vform.languageImportCompleted') }}
  </div>
  <div
      v-if="!completed && stringsToImport"
      @click="importLanguage"
      class="settings-button d-inline-block mt-3">
    {{ $t('vform.importLanguage') }}
  </div>
  <div
      v-if="completed"
      @click="reset"
      class="settings-button d-inline-block mt-3">
    {{ $t('vform.addAnotherFile') }}
  </div>
</div>
</template>

<script>
import UploadDropZone from "@/components/files/UploadDropZone.vue";
import LanguageHandler from "./LanguageHandler";
import LanguageSelector from "@/components/forms/LanguageSelector.vue";
export default {
  name: "LanguageImport",
  components: {
    LanguageSelector,
    UploadDropZone,
  },
  props: {
    organizationId: {type: String, required: true},
    projectId: {type: String, required: true},
    formId: {type: String, required: true},
    config: {type: Object, required: true},
  },
  data() {
    return {
      targetLanguage: null,
      stringsToImport: null,
      importingFileType: 'po',
      LanguageHandler,
      completed: false
    }
  },
  methods: {
    setTranslationData(fileContent) {
      fileContent = this.dataUrlToUtf8String(fileContent);
      this.stringsToImport = this[`parse${this.importingFileType.toUpperCase()}FileContent`](fileContent);
    },
    // attention: method is in used by dynamic call
    parsePOFileContent(poContent) {
      // PO files from Windows use CRLF; normalize before splitting entries.
      poContent = poContent.replace(/\r\n?/g, '\n');
      const translations = {};
      const itemWithoutHeader = poContent.slice(poContent.indexOf('msgctxt'));
      const entries = itemWithoutHeader.split(/\n\n(?=#|msgctxt|msgid)/); // crude split
      console.log('entries', entries);
      entries.forEach(entry => {
        const contextMatch = entry.match(/msgctxt\s+"([^"]+)"/);
        const uuid = contextMatch ? contextMatch[1] : null;

        const extract = (key) => {
          const regex = new RegExp(`${key}\\s+"([^"]*)"([\\s\\S]*?)(?=\\nmsg|$)`);
          const match = entry.match(regex);
          if (!match) return "";
          // combine all quoted lines
          const allQuotes = match[0].match(/"(.*?)"/g) || [];
          return allQuotes.map(q => q.slice(1, -1)).join("");
        };

        const original = extract("msgid");
        const translated = extract("msgstr");

        if (uuid && original) translations[uuid] = { original, translated };
      });
      return translations;
    },
    dataUrlToUtf8String(dataUrl) {
      const b64 = dataUrl.replace(/^data:.*;base64,/, "");
      const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
      return new TextDecoder("utf-8").decode(bytes);
    },
    queueEmpty() {
      console.log('upload queue empty');
    },
    importLanguage() {
      this.completed = false;
      const lh = new LanguageHandler(this.config);
      lh.importLanguageStrings(this.targetLanguage, this.stringsToImport);
      this.$emit('importFinished')
      this.completed = true;
      this.stringsToImport = null;
    },
    reset() {
      this.completed = false;
      this.stringsToImport = null;
      this.targetLanguage = null;
    }
  }
}
</script>

<style lang="scss">
.language-import .language-selector {
  background-color: var(--vform-editor-ui-secondary-color) !important;
  height: auto;
  padding-top: 2px !important;
}
</style>

<style lang="scss" scoped>
.translation-upload {
  max-width: 300px;
}
</style>
